<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">account_balance_wallet</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Ready To Pay {{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Vendor ID</th>
							<th>Vendor Name</th>
							<th>Type</th>
							<th>Trans #</th>
							<th>Reference</th>
							<th>Date</th>
							<th>Due Date</th>
							<th>Amount</th>
							<th>Balance</th>
							<th>Actions</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.supplierid }}</td>
							<td>{{ v.suppname }}</td>
							<td>{{ v.typename }}</td>
							<td>{{ v.transno }}</td>
							<td>{{ v.suppreference }}</td>
							<td>{{ v.trandate }}</td>
							<td>{{ v.duedate }}</td>
							<td>{{ getAmount(v) | currency }}</td>
							<td>{{ getBalance(v) | currency }}</td>
							<td>
								<button mat-icon-button (click)="navigateToVendor(v.supplierid)" matTooltip="View Vendor" *ngIf="v.supplierid">
									<mat-icon>visibility</mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Ready To Pay"
				icon="account_balance_wallet"
				accent="warning"
				[value]="readyToPayLoaded ? readyToPay.length : null"
				[loading]="!readyToPayLoaded"
				[showView]="readyToPayLoaded"
				(view)="toggleFlip(readyToPay, 'All')">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
